/**
 * @generated SignedSource<<061ce6fb71ea55fd21d9cee98ac686ff>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VotableOrder = "HOT" | "NEWEST" | "OLDEST";
export type CommentCommentsLazyQuery$variables = {
  commentId: string;
  order?: VotableOrder | null | undefined;
};
export type CommentCommentsLazyQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"CommentFragment">;
  };
};
export type CommentCommentsLazyQuery = {
  response: CommentCommentsLazyQuery$data;
  variables: CommentCommentsLazyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "commentId"
  }
],
v2 = {
  "kind": "Variable",
  "name": "order",
  "variableName": "order"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": "viewerCanDelete",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "DELETE_COMMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"DELETE_COMMENT\")"
},
v6 = {
  "alias": "viewerCanUpdate",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "UPDATE_COMMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"UPDATE_COMMENT\")"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "edited",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topic",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Forum",
      "kind": "LinkedField",
      "name": "forum",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            (v3/*:: as any*/),
            (v4/*:: as any*/)
          ],
          "storageKey": null
        },
        (v4/*:: as any*/)
      ],
      "storageKey": null
    },
    (v4/*:: as any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Comment",
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": [
    (v4/*:: as any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v4/*:: as any*/),
    (v12/*:: as any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v13/*:: as any*/),
        (v14/*:: as any*/)
      ],
      "type": "Entity",
      "abstractKey": "__isEntity"
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": "viewerCanReply",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "CREATE_COMMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"CREATE_COMMENT\")"
},
v17 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v18 = [
  (v17/*:: as any*/),
  (v2/*:: as any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hotness",
  "storageKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voterCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v17/*:: as any*/)
      ],
      "concreteType": "VotersConnection",
      "kind": "LinkedField",
      "name": "voters",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EntityEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v3/*:: as any*/),
                (v12/*:: as any*/),
                {
                  "kind": "TypeDiscriminator",
                  "abstractKey": "__isEntity"
                },
                (v13/*:: as any*/),
                (v14/*:: as any*/),
                (v4/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "voters(first:10)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EntityVote",
      "kind": "LinkedField",
      "name": "voted",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "score",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "viewerCanVote",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "PUBLISH_VOTE"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"PUBLISH_VOTE\")"
    }
  ],
  "type": "Votable",
  "abstractKey": "__isVotable"
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v24 = {
  "alias": null,
  "args": (v18/*:: as any*/),
  "filters": [
    "order"
  ],
  "handle": "connection",
  "key": "CommentCommentsFragment_children",
  "kind": "LinkedHandle",
  "name": "children"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentCommentsLazyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": [
                  (v2/*:: as any*/),
                  {
                    "kind": "Literal",
                    "name": "topLevel",
                    "value": true
                  }
                ],
                "kind": "FragmentSpread",
                "name": "CommentFragment"
              }
            ],
            "type": "Comment",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "CommentCommentsLazyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              (v15/*:: as any*/),
              (v16/*:: as any*/),
              {
                "alias": null,
                "args": (v18/*:: as any*/),
                "concreteType": "CommentConnection",
                "kind": "LinkedField",
                "name": "children",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CommentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v19/*:: as any*/),
                      (v20/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*:: as any*/),
                          (v5/*:: as any*/),
                          (v6/*:: as any*/),
                          (v7/*:: as any*/),
                          (v8/*:: as any*/),
                          (v9/*:: as any*/),
                          (v10/*:: as any*/),
                          (v11/*:: as any*/),
                          (v15/*:: as any*/),
                          (v16/*:: as any*/),
                          {
                            "alias": null,
                            "args": (v18/*:: as any*/),
                            "concreteType": "CommentConnection",
                            "kind": "LinkedField",
                            "name": "children",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CommentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v19/*:: as any*/),
                                  (v20/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*:: as any*/),
                                      (v5/*:: as any*/),
                                      (v6/*:: as any*/),
                                      (v7/*:: as any*/),
                                      (v8/*:: as any*/),
                                      (v9/*:: as any*/),
                                      (v10/*:: as any*/),
                                      (v11/*:: as any*/),
                                      (v15/*:: as any*/),
                                      (v16/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": (v18/*:: as any*/),
                                        "concreteType": "CommentConnection",
                                        "kind": "LinkedField",
                                        "name": "children",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CommentEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              (v19/*:: as any*/),
                                              (v20/*:: as any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Comment",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*:: as any*/),
                                                  (v5/*:: as any*/),
                                                  (v6/*:: as any*/),
                                                  (v7/*:: as any*/),
                                                  (v8/*:: as any*/),
                                                  (v9/*:: as any*/),
                                                  (v10/*:: as any*/),
                                                  (v11/*:: as any*/),
                                                  (v15/*:: as any*/),
                                                  (v16/*:: as any*/),
                                                  {
                                                    "alias": null,
                                                    "args": (v18/*:: as any*/),
                                                    "concreteType": "CommentConnection",
                                                    "kind": "LinkedField",
                                                    "name": "children",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "CommentEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          (v19/*:: as any*/),
                                                          (v20/*:: as any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Comment",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v4/*:: as any*/),
                                                              (v5/*:: as any*/),
                                                              (v6/*:: as any*/),
                                                              (v7/*:: as any*/),
                                                              (v8/*:: as any*/),
                                                              (v9/*:: as any*/),
                                                              (v10/*:: as any*/),
                                                              (v11/*:: as any*/),
                                                              (v15/*:: as any*/),
                                                              (v16/*:: as any*/),
                                                              {
                                                                "alias": null,
                                                                "args": (v18/*:: as any*/),
                                                                "concreteType": "CommentConnection",
                                                                "kind": "LinkedField",
                                                                "name": "children",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "CommentEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      (v19/*:: as any*/),
                                                                      (v20/*:: as any*/),
                                                                      {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "Comment",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v4/*:: as any*/),
                                                                          (v5/*:: as any*/),
                                                                          (v6/*:: as any*/),
                                                                          (v7/*:: as any*/),
                                                                          (v8/*:: as any*/),
                                                                          (v9/*:: as any*/),
                                                                          (v10/*:: as any*/),
                                                                          (v11/*:: as any*/),
                                                                          (v15/*:: as any*/),
                                                                          (v16/*:: as any*/),
                                                                          {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "numChildren",
                                                                            "storageKey": null
                                                                          },
                                                                          (v3/*:: as any*/),
                                                                          (v21/*:: as any*/)
                                                                        ],
                                                                        "storageKey": null
                                                                      }
                                                                    ],
                                                                    "storageKey": null
                                                                  },
                                                                  (v22/*:: as any*/),
                                                                  (v23/*:: as any*/)
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              (v24/*:: as any*/),
                                                              (v3/*:: as any*/),
                                                              (v21/*:: as any*/)
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v22/*:: as any*/),
                                                      (v23/*:: as any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v24/*:: as any*/),
                                                  (v3/*:: as any*/),
                                                  (v21/*:: as any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v22/*:: as any*/),
                                          (v23/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v24/*:: as any*/),
                                      (v3/*:: as any*/),
                                      (v21/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v22/*:: as any*/),
                              (v23/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v24/*:: as any*/),
                          (v3/*:: as any*/),
                          (v21/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v22/*:: as any*/),
                  (v23/*:: as any*/)
                ],
                "storageKey": null
              },
              (v24/*:: as any*/),
              (v21/*:: as any*/)
            ],
            "type": "Comment",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "89a57a8e69c3bd1c735b74cc2e81ec2b",
    "id": null,
    "metadata": {},
    "name": "CommentCommentsLazyQuery",
    "operationKind": "query",
    "text": "query CommentCommentsLazyQuery(\n  $commentId: ID!\n  $order: VotableOrder\n) {\n  node(id: $commentId) {\n    __typename\n    ... on Comment {\n      ...CommentFragment_28oB9U\n    }\n    id\n  }\n}\n\nfragment CommentCommentsFragment_1CbDfQ on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_3zZj4p\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_28oB9U on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_4kTGy2\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_3zZj4p on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_4hzBTb\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_4hzBTb on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_2rOHm3\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_4kTGy2 on Comment {\n  children(first: 10, order: $order) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_1CbDfQ\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentDeleteFragment on Comment {\n  id\n  author {\n    id\n  }\n  topic {\n    id\n  }\n  parent {\n    id\n  }\n}\n\nfragment CommentDisplayFragment on Comment {\n  viewerCanDelete: viewerCan(action: DELETE_COMMENT)\n  viewerCanUpdate: viewerCan(action: UPDATE_COMMENT)\n  id\n  content\n  edited\n  createdAt\n  topic {\n    forum {\n      owner {\n        __typename\n        id\n      }\n      id\n    }\n    id\n  }\n  parent {\n    id\n  }\n  ...CommentDeleteFragment\n  author {\n    id\n    username\n    ...EntityProfilePicFragment_49kWkb\n  }\n  ...VoteDisplayFragment\n}\n\nfragment CommentFragment_1CbDfQ on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_1CbDfQ\n}\n\nfragment CommentFragment_28oB9U on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_28oB9U\n}\n\nfragment CommentFragment_2rOHm3 on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  numChildren\n}\n\nfragment CommentFragment_3zZj4p on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_3zZj4p\n}\n\nfragment CommentFragment_4hzBTb on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_4hzBTb\n}\n\nfragment CommentFragment_4kTGy2 on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_4kTGy2\n}\n\nfragment CommentReplyFragment on Comment {\n  id\n  viewerCanReply: viewerCan(action: CREATE_COMMENT)\n  topic {\n    forum {\n      owner {\n        __typename\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment EntitiesAvatarFragment on VotersConnection {\n  edges {\n    node {\n      __typename\n      username\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment VoteDisplayFragment on Votable {\n  __isVotable: __typename\n  id\n  votes\n  voterCount\n  voters(first: 10) {\n    ...EntitiesAvatarFragment\n  }\n  voted @ifAllowed {\n    score\n  }\n  viewerCanVote: viewerCan(action: PUBLISH_VOTE)\n}\n"
  }
};
})();

(node as any).hash = "489396ccc487a716eeff3e9b963e4927";

export default node;
